import { render } from "./Headerbar2.vue?vue&type=template&id=e561f736&scoped=true"
import script from "./Headerbar2.vue?vue&type=script&lang=js"
export * from "./Headerbar2.vue?vue&type=script&lang=js"

import "./Headerbar2.vue?vue&type=style&index=0&id=e561f736&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e561f736"]])

export default __exports__